var map = {
	"./BasicPluginsModule.js": 95,
	"./es.upv.paella.audioSelector.js": 252,
	"./es.upv.paella.backwardButtonPlugin.js": 925,
	"./es.upv.paella.captionsSelectorPlugin.js": 460,
	"./es.upv.paella.customTimeProgressIndicator.js": 787,
	"./es.upv.paella.downloadsPlugin.js": 61,
	"./es.upv.paella.externalPluginTest.js": 800,
	"./es.upv.paella.findCaptionsPlugin.js": 623,
	"./es.upv.paella.forwardButtonPlugin.js": 108,
	"./es.upv.paella.fullscreenButton.js": 440,
	"./es.upv.paella.hlsCaptionsSelectorPlugin.js": 738,
	"./es.upv.paella.keyboardShortcutsHelp.js": 234,
	"./es.upv.paella.layoutSelector.js": 239,
	"./es.upv.paella.liveStreamingProgressIndicator.js": 592,
	"./es.upv.paella.playbackRateButton.js": 540,
	"./es.upv.paella.qualitySelector.js": 135,
	"./es.upv.paella.volumeButtonPlugin.js": 459
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 757;